<template>
    <h1>About</h1>

    <div class="about container">
        <p>
            The Anime Quiz Database is a project started and maintained by
            <span class="promo"><a href="https://instagram.com/lysus20">Lysus</a></span>
            also known as Austin. This project started from Lysus' passion
            for hosting gameshow panels in vaious anime conventions.
            Austin has hosted Anime Jeopardy, Anime Music Quiz, The Anime Dating game,
            and many other different panels at cons such as Level Up Expo, Tsumicon,
            Shinecon, and others across the country.
            <br>
            <br>
            This project was birthed from his love of anime, hosting gameshows, and web
            development. This database will be used to help host his future panels
            and hopefully help others who also wish to made games and panels by
            accessing the database to help create their games to use themselves.
            <br>
            <br>
            The project is still in it's early stages and currently the plan is to
            create a few trivia games that can demonstrate what can be done using
            this database and making an API so other developers can use it. Other
            ideas also include making it so the community can contribute trivia
            questions as well and possibly make a community based approval system
            to create new questions and categories. Currently however, any new
            categories and questions will be manually approved.
        </p>
    </div>
    <br>
    <br>
</template>

<script>
export default {

}
</script>

<style>
.about {
    text-align: center;
    margin: 0 auto;
    padding: 20px;
    border-radius: 10px;
    background: white;
    max-width: 720px;
}
.promo {
    text-decoration: underline;
}
</style>